global.BvAdmin = {
  services: {},
  functions: {},
};
